
<button class="btn btn-lg bg-white float-right" [routerLink]="['./add']"><i class="align-middle fas fa-plus-circle"></i> New Office </button>

<table class="neu-table table table-striped neu-table w-100" datatable [dtOptions]="dtOptions" data-page="2" ></table>

